export default __webpack_public_path__ + "static/media/fish.976b0bf3.png";